import { cloneProxyObject } from '@/utils/cloneProxyObject';
import { Chart, ChartStyle } from '@/interfaces/chart';

export function extractChartStyleObject(chartObject: Chart | ChartStyle): ChartStyle {
  return cloneProxyObject({
    chartType: chartObject.chartType,
    period: chartObject.period,
    range: chartObject.range,
    rangeBar: chartObject.rangeBar,
    rangeGap: chartObject.rangeGap,
    rangeExtraBars: chartObject.rangeExtraBars,
    rangeDays: chartObject.rangeDays,
    rangeMonths: chartObject.rangeMonths,
    rangeYears: chartObject.rangeYears,
    rangeStartDate: chartObject.rangeStartDate,
    rangeEndDate: chartObject.rangeEndDate,
    perfChartSymbols: chartObject.perfChartSymbols,
    useMainChartSymbolAsBaseline: chartObject.useMainChartSymbolAsBaseline,
    colorScheme: chartObject.colorScheme,
    customColorSchemeBackgroundColor: chartObject.customColorSchemeBackgroundColor,
    customColorSchemeGridColor: chartObject.customColorSchemeGridColor,
    customColorSchemeTextColor: chartObject.customColorSchemeTextColor,
    customColorSchemeIndicatorColor: chartObject.customColorSchemeIndicatorColor,
    upColor: chartObject.upColor,
    downColor: chartObject.downColor,
    opacity: chartObject.opacity,
    chartSize: chartObject.chartSize,
    customWidth: chartObject.customWidth,
    customHeight: chartObject.customHeight,
    chartGrid: chartObject.chartGrid,
    legends: chartObject.legends,
    isLogScale: chartObject.isLogScale,
    extendedHours: chartObject.extendedHours,
    fullQuote: chartObject.fullQuote,
    priceLabels: chartObject.priceLabels,
    yAxisLabels: chartObject.yAxisLabels,
    solidCandles: chartObject.solidCandles,
    colorVolume: chartObject.colorVolume,
    zoomThumbnail: chartObject.zoomThumbnail,
    chartSettingsVolumeMenuValue: chartObject.chartSettingsVolumeMenuValue,
    kagiReversal: chartObject.kagiReversal,
    kagiUnit: chartObject.kagiUnit,
    kagiPriceField: chartObject.kagiPriceField,
    renkoBoxSize: chartObject.renkoBoxSize,
    renkoUnit: chartObject.renkoUnit,
    renkoPriceField: chartObject.renkoPriceField,
    sortedIndicators: chartObject.sortedIndicators,
    sortedOverlays: chartObject.sortedOverlays
  });
}
